import moment from 'moment';
import { capitalize } from '../../../../../helpers';

export const DateText = ({
  date,
  format = 'DD MMM YY',
}: {
  format?: string;
  date: string;
}) => (
  <div className="date">
    {date ? moment(date).format(format) : 'Not available'}
  </div>
);

export const dateTimeDetailsFormatter = ({ date }: { date: string }) =>
  date ? moment(date).format('HH:mm:ss DD MMM YY') : 'Not available';

interface DetailListProps {
  details: Record<string, string | number | null | undefined>;
}

export const DetailList = ({ details }: DetailListProps) => (
  <ul className="details-list">
    {Object.entries(details)
      .filter(([_, value]) => value !== null && value !== undefined)
      .map(([key, value]) => (
        <li key={key}>{`${capitalize(key)}: ${value}`}</li>
      ))}
  </ul>
);
